import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import About from "./About"; // 두 번째 화면
import Navbar from "./Navbar";
import ConferenceOverview from "./ConferenceOverview";
import Introduction1 from "./Introduction1";
import Introduction2 from "./Introduction2";
import Highlights from "./Highlights";
import GetTicket from "./GetTicket";
import Sponsors from "./Sponsors";
import Footer from "./Footer";
import Modal from "./Modal"
import MobileMenu from "./MobileMenu";
import FloatingCTA from "./FloatingCTA";

const IntroAnimation = () => {
  const [showAbout, setShowAbout] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);


  // 일정 시간 후 About 컴포넌트로 변경
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowAbout(true);
    }, 3000); // 3초 후 전환

    return () => clearTimeout(timer);
  }, []);

  if (showAbout) {
    return (
      <div className="w-full bg-black-900">
        <div className="relative w-full">
          <Navbar setMenuOpen={setMenuOpen} menuOpen={menuOpen} />
        </div>
        <div>
          <About />
          <ConferenceOverview />
          <Introduction1 />
          <Introduction2 />
          <Highlights setIsModalOpen={setIsModalOpen} setContent={setContent} setTitle={setTitle} />
          <GetTicket />
          <Sponsors />
          {menuOpen && <MobileMenu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />}
          <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} title={title} content={content} />
          <Footer />
          <FloatingCTA />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-black gap-4">
      {/* EXPAND - 기울기 및 그라디언트 적용 */}
      <motion.h1
        className="desktop:text-[200px] mobile:text-[90px] tablet:text-[150px] font-extrabold bg-clip-text"
        style={{
          backgroundImage: "linear-gradient(88deg, rgba(104, 86, 214, 0.49) 0%, rgba(112, 89, 255, 1) 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          // textShadow: "0px 20px 50px rgba(0, 0, 0, 0.7)"
        }}
        initial={{ scale: 2, rotate: -88, skewY: 10, x: -1000 }}
        animate={{ scale: 1, rotate: 0, skewY: 0, x: 0 }}
        transition={{ type: "spring", stiffness: 180, damping: 30, duration: 0.4, bounce: 0.2, delay: 0 }}
      >
        EXPAND
      </motion.h1>

      {/* CONNECT */}
      <motion.h1
        className="desktop:text-[200px] mobile:text-[90px] tablet:text-[150px] font-extrabold bg-clip-text desktop:mt-[-100px] tablet:mt-[-70px] mobile:mt-[-40px]"
        style={{
          backgroundImage: "linear-gradient(94deg, rgba(147, 232, 255, 1) 0%, rgba(147, 232, 255, 0.2) 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          // textShadow: "0px 20px 50px rgba(0, 0, 0, 0.7)"
        }}
        initial={{ scale: 2, rotate: -94, x: 2000 }}
        animate={{ scale: 1, rotate: 0, x: 0 }}
        transition={{ type: "spring", stiffness: 180, damping: 30, duration: 0.4, bounce: 0.2, delay: 0.1 }}
      >
        CONNECT
      </motion.h1>


      {/* BEYOND */}
      <motion.h1
        className="desktop:text-[200px] mobile:text-[90px] tablet:text-[150px] font-extrabold text-[#EE3E5D] desktop:mt-[-100px] tablet:mt-[-70px] mobile:mt-[-40px]"
        style={{
          backgroundImage: "linear-gradient(86deg, rgba(238, 62, 93, 0.5) 0%, rgba(238, 62, 93, 1) 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          // textShadow: "0px 20px 50px rgba(0, 0, 0, 0.7)"
        }}
        initial={{ scale: 2, rotate3d: [0, 0, -20], x: -2000 }}
        animate={{ scale: 1, rotate3d: [0, 0, 0], x: 0 }}
        transition={{ type: "spring", stiffness: 180, damping: 30, duration: 0.4, bounce: 0.2, delay: 0.2 }}
      >
        BEYOND
      </motion.h1>
    </div>
  );
};

export default IntroAnimation;
